import * as React from 'react'
import dayjs from 'dayjs'
import { TableOLD } from '@lmc/ui-kit'
import { sizes } from '@lmc/common/constants'
import './CareDeliveryTable.less'
import { Skeleton } from 'antd'
import { Data } from '../../CareDeliveryScreen.types'
import { LogCategory, LogCategoryItem } from '@lmc/ts-common'
import { formatTableData, getTableColumns } from './CareDeliveryTable.utils'
import useSafeguardingAccess from 'components/AccessControl/useSafeguardingAccess'
import { SAFEGUARDING_ITEM_ID } from '@lmc/common/types'

export type CareDeliveryTableProps = {
  items: LogCategoryItem[]
  categories: LogCategory[]
  to: dayjs.Dayjs
  from: dayjs.Dayjs
  data: Data[]
  categoryId: string
  isLoading: boolean
  preferredPeopleNominative: string
}

export const CareDeliveryTable = ({
  data,
  items,
  to,
  from,
  categories,
  categoryId,
  isLoading,
  preferredPeopleNominative
}: CareDeliveryTableProps): React.ReactElement => {
  if (!data || !items || !categories) {
    return (
      <div className="care-delivery-skeleton">
        <Skeleton active />
      </div>
    )
  }

  const safeguardingAccess = useSafeguardingAccess()

  const filteredItems = safeguardingAccess
    ? items
    : items.filter((item) => item.id !== SAFEGUARDING_ITEM_ID)

  const columns = getTableColumns({
    items: filteredItems,
    to,
    from,
    categories,
    categoryId,
    preferredPeopleNominative
  })

  const tableData = formatTableData(data)

  return (
    <TableOLD
      containerClass="table-striped"
      size="middle"
      loading={isLoading}
      scroll={{ x: sizes.childScreen }}
      pagination={{
        pageSize: 10,
        position: ['bottomRight']
      }}
      columns={columns}
      rows={tableData}
    />
  )
}

export default CareDeliveryTable
